module.exports = __webpack_public_path__ + "static/media/plug.6711c38e.svg";